import React, { useEffect, useState } from "react";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../../firebase-config";
import HomeSnapshot from "./HomeSnapshot";
import HomeSnapshotLoader from "./HomeSnapshotLoader";

export default function LastMonthInflation() {
  const [Inflation, setInflation] = useState();
  const [loading, setLoading] = useState(false);
  const date = new Date();
  let year = date.getFullYear();

  if (date.getMonth() === 0) {
    year = date.getFullYear() - 1;
  }

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  let lastMonth = months[date.getMonth() - 1];
  if (date.getMonth() === 0) {
    lastMonth = "December";
  }

  useEffect(() => {
    setLoading(true);
    async function getDocuments() {
      const q = query(
        collection(db, "inflation"),
        where("country", "==", "Kenya"),
        where("year", "==", year),
        where("month", "==", lastMonth)
      );
      const allDocs = [];
      const querySnapshot = await getDocs(q);
      querySnapshot.forEach((doc) => {
        allDocs.push(doc.data());
      });

      if (allDocs.length > 0) {
        setInflation(allDocs[0]["inflation-rate"]);
      }
      setLoading(false);
    }
    getDocuments();
  }, [lastMonth, year]);

  return loading ? (
    <HomeSnapshotLoader />
  ) : Inflation !== undefined ? (
    <HomeSnapshot
      data={`${Inflation}%`}
      description={`${lastMonth} ${year} Inflation Rate`}
    />
  ) : (
    <></>
  );
}
